import { toMedicareTag } from "../merge-tags-options/patient-medicare-insurance-policy.utils";
import { type MergeTagsReplaceHandler } from "./merge-tags-values";
import { PATIENT_PRIMARY_INSURANCE_POLICY_VALUES } from "./patient-primary-insurance-policy-values.utils";

// SN-19877: each Medicare tag is its primary policy tag, read from the Medicare policy. The primary
// handlers only ever read `patient.primary_insurance_policy`, so handing them the Medicare policy in
// its place gives the same formatting with one implementation. No Medicare policy (or a backend
// that doesn't send the field yet) means every Medicare tag prints nothing.
export const PATIENT_MEDICARE_INSURANCE_POLICY_VALUES: MergeTagsReplaceHandler =
  Object.fromEntries(
    Object.entries(PATIENT_PRIMARY_INSURANCE_POLICY_VALUES).map(
      ([primaryTag, handler]) => [
        toMedicareTag(primaryTag),
        (params) => {
          const patient = params.data.patient;
          return handler({
            ...params,
            data: {
              ...params.data,
              patient: patient && {
                ...patient,
                primary_insurance_policy:
                  patient.primary_medicare_insurance_policy ?? undefined
              }
            }
          });
        }
      ]
    )
  );
